import type { Cancel } from 'axios';
import Axios from 'axios';
import { makeError, allExceptionDetails, exceptionEssence } from '../util/exception';

/**
 * A hybrid of Promise.all() and Promise.settleAll() which waits for all
 * promises to settle, but propagates rejections.
 *
 * Optional parameter onError allows for early responses to errors, e.g. to
 * trigger a CancelToken.
 */
export async function combineAll(promises: Promise<any>[]) {
  const cancels: Cancel[] = [];
  const errors: unknown[] = [];

  await Promise.all(
    promises.map((p) =>
      p.catch((ex: unknown) => {
        if (Axios.isCancel(ex)) {
          cancels.push(ex as Cancel);
          return;
        }

        errors.push(ex);
      }))
  );

  if (errors.length) {
    if (errors.length == 1) {
      throw errors[0];
    }

    throw makeError(
      exceptionEssence(errors[0] as any) + ', and more',
      'MultiError',
      {
        info: {
          errorCount: errors.length,
          more: errors.slice(1).map((e) => allExceptionDetails(e as any)),
        },
      }
    );
  }

  if (cancels.length) {
    throw cancels[0];
  }
}
